const DEFAULT_ERROR_MESSAGE = 'Возникла ошибка,\nотправьте запрос заново';

const ERROR_MESSAGE_MAP = {
    406: 'Увы, с таким запросом\nя не могу помочь',
};

export const getLLMErrorMessage = (statusCode: number): string => ERROR_MESSAGE_MAP?.[statusCode] || DEFAULT_ERROR_MESSAGE;
